import { styled } from '@mui/material';
import { Create } from 'shared/react-admin/Create/Create';

export const CreateStyled = styled(Create)({
  '& .RaCreate-main': {
    margin: '0!important',
  },
});
